import type { OidcLocationService } from '.';
import { OidcLocation } from '@axa-fr/oidc-client';
import { injectable } from 'src/features/ioc';

@injectable()
export class WebOidcLocationService implements OidcLocationService {
    #location = new OidcLocation();

    open(url: string): void {
        this.#location.open(url);
    }

    reload(): void {
        this.#location.reload();
    }

    getCurrentHref(): string {
        return this.#location.getCurrentHref();
    }

    getPath(): string {
        return this.#location.getPath();
    }

    getOrigin(): string {
        return this.#location.getOrigin();
    }
}
